import React from 'react';
import { useQuery } from '~~utils/CommonUtils';

const Logout = () => {
  const query = useQuery();
  const doneURL = query.get('done_url');

  window.location.replace(
    `${process.env.REACT_APP_BACKEND_URL}/logout${!doneURL ? '' : `?done_url=${encodeURIComponent(doneURL)}`}`,
  );

  return <div>協助導轉至登出介面</div>;
};

export default Logout;
